import { render, staticRenderFns } from "./DetailsProduct.vue?vue&type=template&id=411904f1&scoped=true"
import script from "./DetailsProduct.vue?vue&type=script&lang=js"
export * from "./DetailsProduct.vue?vue&type=script&lang=js"
import style0 from "./DetailsProduct.vue?vue&type=style&index=0&id=411904f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411904f1",
  null
  
)

export default component.exports